import { get, ENDPOINTS } from "../../../services/shopify";
import { logger } from "../../../core";

export const retryPayment = async (token, gatewayName, sessionID) => {
  try {
    const response = await get({
      endpoint: ENDPOINTS.RETRY,
      token: token,
      query: `${gatewayName}/${sessionID}`,
    });

    return { success: true, response };
  } catch (err) {
    logger.error(`retryPayment(): ${err}`);
    return { success: false, response: {} };
  }
};
